import React, { useMemo } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Box, Chip, Typography, IconButton, TextField, Button } from '@mui/material';
import {
    Group as GroupIcon,
    Link as LinkIcon,
    Visibility as VisibilityIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

export default function WhitelistTable({
    data,
    editingUrl,
    editUrlValue,
    onEditValueChange,
    onSaveEdit,
    onCancelEdit,
    onStartEdit,
    onDelete,
    onViewDetails
}) {
    const columns = useMemo(() => [
        {
            accessorKey: 'type',
            header: 'Tipo',
            size: 60,
            Cell: ({ cell }) => {
                const type = cell.getValue();
                return (
                    <Chip
                        icon={type === 'group' ? <GroupIcon /> : <LinkIcon />}
                        label={type === 'group' ? 'Gruppo' : 'URL'}
                        color={type === 'group' ? 'primary' : 'default'}
                        size="small"
                        sx={{ fontSize: '0.65rem' }}
                    />
                );
            }
        },
        {
            accessorKey: 'url',
            header: 'URL / Nome Gruppo',
            size: 180,
            Cell: ({ cell, row }) => {
                const item = row.original;
                const isEditing = editingUrl === item.id && item.type === 'url';

                if (item.type === 'group') {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.75rem' }}>{item.groupName}</Typography>
                            <IconButton size="small" sx={{ padding: '2px' }} onClick={() => onViewDetails(item.id)}>
                                <VisibilityIcon sx={{ fontSize: '0.9rem' }} />
                            </IconButton>
                        </Box>
                    );
                }

                return isEditing ? (
                    <TextField
                        value={editUrlValue}
                        onChange={(e) => onEditValueChange(e.target.value)}
                        size="small"
                        fullWidth
                        autoFocus
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') onSaveEdit(item.id);
                            if (e.key === 'Escape') onCancelEdit();
                        }}
                    />
                ) : (
                    <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>{cell.getValue()}</Typography>
                );
            }
        },
        {
            accessorKey: 'createdAt',
            header: 'Data aggiunta',
            size: 100,
            Cell: ({ cell }) => {
                const val = cell.getValue();
                try {
                    return new Date(val).toLocaleString('it-IT');
                } catch {
                    return '-';
                }
            }
        },
        {
            accessorKey: 'actions',
            header: 'Azioni',
            enableSorting: false,
            size: 70,
            Cell: ({ row }) => {
                const item = row.original;
                const isEditing = editingUrl === item.id;
                return (
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                        {isEditing ? (
                            <>
                                <Button size="small" variant="contained" onClick={() => onSaveEdit(item.id)} sx={{ fontSize: '0.65rem', padding: '2px 4px' }}>Salva</Button>
                                <Button size="small" variant="outlined" onClick={onCancelEdit} sx={{ fontSize: '0.65rem', padding: '2px 4px' }}>Ann.</Button>
                            </>
                        ) : (
                            <>
                                {item.type === 'url' && (
                                    <IconButton size="small" color="primary" onClick={() => onStartEdit(item.id, item.url)} sx={{ padding: '2px' }}>
                                        <EditIcon sx={{ fontSize: '0.9rem' }} />
                                    </IconButton>
                                )}
                                <IconButton size="small" color="error" onClick={() => onDelete(item.id)} sx={{ padding: '2px' }}>
                                    <DeleteIcon sx={{ fontSize: '0.9rem' }} />
                                </IconButton>
                            </>
                        )}
                    </Box>
                );
            }
        }
    ], [editingUrl, editUrlValue, onEditValueChange, onSaveEdit, onCancelEdit, onStartEdit, onDelete, onViewDetails]);

    return (
        <MaterialReactTable
            columns={columns}
            data={data}
            enablePagination={false}
            enableBottomToolbar={false}
            enableTopToolbar={false}
            enableColumnFilters={false}
            initialState={{ showGlobalFilter: false }}
            muiTableBodyCellProps={{
                sx: {
                    fontSize: '0.75rem',
                    padding: '6px 8px',
                }
            }}
            muiTableHeadCellProps={{
                sx: {
                    fontSize: '0.8rem',
                    padding: '8px 4px',
                }
            }}
        />
    );
}